import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class SMSSenderService {

    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService,
        private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }


    sendSMS(message: string, phoneNumber: string): Observable<any> {

        const params = {
            message, phoneNumber
        };

        return this.httpClient.post(this.baseApiUrl + 'smssender', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

}
